"use strict";

import Dom from "common/Dom";
import * as handlers from "scripts/components/Overlay/handlers";
import * as handlers2 from "scripts/components/Scroll/handlers";
var lastFocus;
var modalOpened;
export const openModal = function openModal() {
  if ($(Dom.mailChimpModal).length > 0) {
    $(Dom.mailChimpModal).addClass("is-active");
    modalOpened = true;
    handlers.showOverlay();
    handlers2.scrollLock();
    lastFocus = document.activeElement; //Stores focused element before modal opens

    $(document).on("keydown", function (event) {
      if (event.which === 27 && modalOpened) {
        event.preventDefault();
        closeModal();
      }
    });
  }
};
var mc1Submitted = false;
$("#mc-embedded-subscribe-form").on("submit reset", function (event) {
  if ("submit" === event.type) {
    setTimeout(function () {
      closeModal();
    }, 3000);
  }
});
export const closeModal = function closeModal() {
  if ($(Dom.mailChimpModal).length > 0) {
    $(Dom.mailChimpModal).removeClass("is-active");
    modalOpened = false;
    handlers.hideOverlay();
    handlers2.scrollUnlock();
    if (!modalOpened) {
      lastFocus.focus(); // Return focus to the last focused element before modal opened
    }
  }
};
